import { BrandType } from '../../../types/brand'
// TODO: (Ensure this is implemented) This gets swapped out for the prod version at build time when building for prod
import { MSalConfig } from '../../../config/msal-configs/base/msal-config-test'

export interface URLConfig {
	MyAccountProfileURL: string
	MyAccountRewardsURL: string
	MyAccountVehicleURL: string
	MyAccountMissingInfoURL: string
	NotificationInboxURL: string
	CartURL?: string
	KoreanProfileRefreshURL?: string
	KoreanCheckJsonURL?: string
	rewardsUseLoyaltyHeaders?: boolean
	logoutURL: string
}

export interface AuthConfig {
	tenant: string
	authority: string
	policy: string
	clientID: string
	authScopes: string[]
	approvedAuthorities: string[]
	// Ideas for other fields:
	// redirectUrl: string
	// verificationFailureUrl: string
}

export abstract class NavConfig {
	protected _brand: BrandType
	protected _channel = 'globalnav'
	protected _region: string
	protected _direction = 'ltr'
	protected _language: string
	_urls: URLConfig = {
		MyAccountProfileURL: '/api/_gbpe/v3/profiles',
		MyAccountRewardsURL: '',
		MyAccountVehicleURL: '',
		MyAccountMissingInfoURL: '',
		NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
		CartURL: '',
		KoreanProfileRefreshURL: '',
		KoreanCheckJsonURL: '',
		logoutURL: location.origin,
	}
	/*
		Need to look into inheriting just parts of this config like `authScopes`, etc.
	*/
	protected _auth: AuthConfig = {
		...MSalConfig,
		authScopes: ['openid', 'profile'],
	}

	get urls(): URLConfig {
		return this._urls
	}

	get region(): string {
		return this._region
	}

	get direction(): string {
		return this._direction
	}

	get language(): string {
		return this._language
	}

	get auth(): AuthConfig {
		return this._auth
	}

	get brand(): BrandType {
		return this._brand
	}

	get channel(): string {
		return this._channel
	}
}
